import React from "react";
import { Grid, TextField, MenuItem } from "@mui/material";

export const AddressFields = ({
  profileData,
  handleChange,
  postOffices,
  pincodeError,
  t,
  errors,
}) => (
  <>
    <Grid item xs={12}>
      <TextField
        label={t("Pincode")}
        name="pin_code"
        value={profileData.pin_code || ""}
        onChange={(e) => handleChange(e.target.name, e.target.value)}
        fullWidth
        error={!!errors.pin_code || !!pincodeError}
        helperText={errors.pin_code || pincodeError}
      />
    </Grid>

    <Grid item xs={12}>
      <TextField
        label={t("State")}
        name="state"
        value={profileData.state || ""}
        onChange={(e) => handleChange(e.target.name, e.target.value)}
        fullWidth
        error={!!errors.state}
        helperText={errors.state}
        select
        disabled
      >
        {postOffices.map((office) => (
          <MenuItem key={office.Name} value={office.State}>
            {office.State}
          </MenuItem>
        ))}
      </TextField>
    </Grid>

    <Grid item xs={12}>
      <TextField
        label={t("District")}
        name="district"
        value={profileData.district || ""}
        onChange={(e) => handleChange(e.target.name, e.target.value)}
        fullWidth
        error={!!errors.district}
        helperText={errors.district}
        select
        disabled
      >
        {postOffices.map((office) => (
          <MenuItem key={office.Name} value={office.District}>
            {office.District}
          </MenuItem>
        ))}
      </TextField>
    </Grid>

    <Grid item xs={12}>
      <TextField
        label={t("Post Office")}
        name="postoffice"
        value={profileData.postoffice || ""}
        onChange={(e) => {
          const selectedOffice = postOffices.find(
            (office) => office.Name === e.target.value
          );
          if (selectedOffice) {
            handleChange("postoffice", selectedOffice.Name);
            handleChange("state", selectedOffice.State);
            handleChange("district", selectedOffice.District);
          }
        }}
        fullWidth
        error={!!errors.postoffice}
        helperText={errors.postoffice}
        select
      >
        {postOffices.map((office) => (
          <MenuItem key={office.Name} value={office.Name}>
            {office.Name}
          </MenuItem>
        ))}
      </TextField>
    </Grid>

    <Grid item xs={12}>
      <TextField
        label={t("Village")}
        name="village"
        value={profileData.village || ""}
        onChange={(e) => handleChange(e.target.name, e.target.value)}
        fullWidth
        error={!!errors.village}
        helperText={errors.village}
      />
    </Grid>

    <Grid item xs={12}>
      <TextField
        label={t("Address Line 1")}
        name="address_line1"
        value={profileData.address_line1 || ""}
        onChange={(e) => handleChange(e.target.name, e.target.value)}
        fullWidth
        error={!!errors.address_line1}
        helperText={errors.address_line1}
      />
    </Grid>

    <Grid item xs={12}>
      <TextField
        label={t("Address Line 2")}
        name="address_line2"
        value={profileData.address_line2 || ""}
        onChange={(e) => handleChange(e.target.name, e.target.value)}
        fullWidth
        error={!!errors.address_line2}
        helperText={errors.address_line2}
      />
    </Grid>
  </>
);
